var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"margin-top":"-24px"},attrs:{"fluid":""}},[_c('v-row',{staticClass:"header-container",staticStyle:{"margin-left":"-24px","margin-right":"-24px"}},[_vm._t("content-cols")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }